import { render, staticRenderFns } from "./ChatsFilter.vue?vue&type=template&id=767fd27c&"
import script from "./ChatsFilter.vue?vue&type=script&lang=js&"
export * from "./ChatsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports